var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuIconCategoryActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.19227 10.615L12 2.73047L16.8078 10.615H7.19227ZM17.5 21.615C16.3525 21.615 15.3798 21.216 14.5818 20.418C13.7838 19.62 13.3848 18.6472 13.3848 17.4997C13.3848 16.3522 13.7838 15.3795 14.5818 14.5815C15.3798 13.7835 16.3525 13.3845 17.5 13.3845C18.6475 13.3845 19.6203 13.7835 20.4183 14.5815C21.2163 15.3795 21.6153 16.3522 21.6153 17.4997C21.6153 18.6472 21.2163 19.62 20.4183 20.418C19.6203 21.216 18.6475 21.615 17.5 21.615ZM3.38477 21.115V13.8845H10.6153V21.115H3.38477ZM17.4998 20.1152C18.2319 20.1152 18.8509 19.8624 19.3568 19.3567C19.8626 18.8511 20.1155 18.2321 20.1155 17.5C20.1155 16.7678 19.8627 16.1488 19.357 15.643C18.8513 15.1371 18.2324 14.8842 17.5003 14.8842C16.7681 14.8842 16.1491 15.1371 15.6433 15.6427C15.1374 16.1484 14.8845 16.7673 14.8845 17.4995C14.8845 18.2316 15.1373 18.8506 15.643 19.3565C16.1487 19.8623 16.7676 20.1152 17.4998 20.1152ZM4.88452 19.6152H9.11552V15.3842H4.88452V19.6152ZM9.83852 9.11522H14.1615L12 5.63822L9.83852 9.11522Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIconCategoryActive);
export default __webpack_public_path__ + "static/media/menu_icon_category_active.1caf2e961afebeec3d6fc598b03e1344.svg";
export { ForwardRef as ReactComponent };